import * as Models from "../Models";
import * as Common from "../Common/modules";

export interface ISystemReviewApiClient {
    loadSystemReviews(systemReviewRequest: Models.Customer.SolarSystemReviewsRequest.ISolarSystemReviewsRequest): ng.IPromise<any>;
    getReviewTypes(): ng.IPromise<any>;
    getReviewVendors(): ng.IPromise<any>;
    saveSystemReview(saveSystemReviewRequest: Models.Customer.SaveSystemReviewRequest.ISaveSystemReviewRequest): ng.IPromise<any>;
    deleteSystemReview(systemReview: Models.Customer.SystemReview.ISystemReview): ng.IPromise<any>;
}

export class SystemReviewApiClient implements ISystemReviewApiClient {
    public static $inject = ['igs.apiClientService'];
    constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
    }

    public loadSystemReviews = (systemReviewRequest: Models.Customer.SolarSystemReviewsRequest.SolarSystemReviewsRequest): ng.IPromise<any> => {
        return this.igsApiClientService.post("GetSystemReviews", systemReviewRequest);
    }

    public getReviewTypes = (): ng.IPromise<any> => {
        return this.igsApiClientService.get("GetReviewTypes");
    }

    public getReviewVendors = (): ng.IPromise<any> => {
        return this.igsApiClientService.get("GetReviewVendors");
    }

    public saveSystemReview = (saveSystemReviewRequest: Models.Customer.SaveSystemReviewRequest.ISaveSystemReviewRequest): ng.IPromise<any> => {
        return this.igsApiClientService.post("SaveSystemReview", saveSystemReviewRequest);
    }

    public deleteSystemReview = (systemReview: Models.Customer.SystemReview.ISystemReview): ng.IPromise<any> => {
        return this.igsApiClientService.post("DeleteSystemReview", systemReview);
    }
}
